import * as React from "react";
import {Fragment} from "react";
import LeadStatusNotification from "../../../model/notification/lead/LeadStatusNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: LeadStatusNotification
}

/**
 * Lead status notification toast body.
 */
const NotificationLeadStatusBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.referenceNumber}</div>
			<div className={"toast-body"}>
				Status changed from:<br/>
				<b>{props.notification.getPreviousStatusLabel()}</b><br/>
				to:<br/>
				<b>{props.notification.getCurrentStatusLabel()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationLeadStatusBody;